// extracted by mini-css-extract-plugin
module.exports =  {"timePicker":"style-module_timePicker__BgN2TfPlgzeD36AmmrKy","digit":"style-module_digit__jAyYPsBPMUefLyKY3TzA"};